
import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = [
    { path: '/', label: 'トップ' },
    { path: '#mission', label: 'ミッション' },
    { path: '#works', label: '事業内容' },
    { path: '#ceo', label: 'メッセージ' },
    { path: '#company', label: '会社概要' },
    { path: '#faq', label: 'よくある質問' },
    { path: '#contact', label: 'お問い合わせ' }
  ];

  const handleNavClick = (path: string) => {
    if (path === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (path.startsWith('#')) {
      const element = document.querySelector(path);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };
  
  return (
    <footer className="bg-[#111827] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* 会社情報 */}
          <div>
            <img 
              src="https://static.readdy.ai/image/0736d0f97af205035455602030a0e7f5/3f1e2363da69610ccf892d613395bdf1.png" 
              alt="ナインバレー株式会社" 
              className="h-8 w-auto mb-4"
            />
            <div className="text-gray-300 space-y-2">
              <p className="font-medium">ナインバレー株式会社</p>
              <p>〒753-0056<br />山口県山口市湯田温泉2丁目4-26</p>
              <p>info@redondo.jp</p>
            </div>
          </div>
          
          {/* リンク */}
          <div>
            <h3 className="text-lg font-semibold mb-4">サイトマップ</h3>
            <nav className="grid grid-cols-2 gap-2">
              {footerLinks.map((link) => (
                <button
                  key={link.path}
                  onClick={() => handleNavClick(link.path)}
                  className="text-gray-300 hover:text-[#40BFB4] cursor-pointer transition-colors duration-200 text-left"
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">© 2025 Nine Valley Inc.</p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-[#40BFB4] text-sm cursor-pointer mt-2 md:mt-0"
          >
            Made with Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
